<template>
  <DsFeaturesSection
    title-base="Características"
    title-highlight="generales"
    title-id="hazte-duena-features-title"
    :title-base-color="'var(--ds-purple-400)'"
    :title-highlight-color="'var(--ds-purple-900)'"
    :features="features"
  />
</template>

<script setup lang="ts">
import homeIcon from '../../../assets/hazte-duena/ic_vivienda.svg'
import realEstateAgentIcon from '../../../assets/hazte-duena/ic_comprador.svg'
import paymentsIcon from '../../../assets/hazte-duena/ic_validacion.svg'
import folderCopyIcon from '../../../assets/hazte-duena/ic_expediente.svg'
import gymnasticsIcon from '../../../assets/hazte-duena/ic_flexibilidad.svg'
import DsFeaturesSection from '../components/DsFeaturesSection.vue'

const features = [
  {
    id: 'housing-type',
    iconSrc: homeIcon,
    title: 'Tipo de vivienda',
    description:
      'Inmuebles en zona urbana/semiurbana con servicios básicos y situación legal correcta.'
  },
  {
    id: 'buyer',
    iconSrc: realEstateAgentIcon,
    title: 'Comprador',
    description:
      'Mujeres (Nómina, Negocio Propio, Actividad Independiente, Comisiones, Rentas, Inversiones).'
  },
  {
    id: 'financial-validation',
    iconSrc: paymentsIcon,
    title: 'Validación financiera',
    description:
      'Revisión de historial, capacidad de pago y endeudamiento (Buró de crédito).'
  },
  {
    id: 'file',
    iconSrc: folderCopyIcon,
    title: 'Expediente',
    description: 'Integración documental de ingresos y validación del inmueble.'
  },
  {
    id: 'flexibility',
    iconSrc: gymnasticsIcon,
    title: 'Flexibilidad inicial',
    description:
      'Consideramos diversas formas de comprobar tus ingresos para adaptarnos a tu realidad financiera.'
  }
]
</script>
